import script from "./DiagnocatMultiUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnocatMultiUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./DiagnocatMultiUploadModal.vue?vue&type=style&index=0&id=26dae1de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26dae1de"]])

export default __exports__